import { cn } from '@workspace/shadcn';

import { usePageMeta } from '../../lib/seo.tsx';
import { DotPattern } from '../components/effects/dot-pattern.tsx';
import { AboutUs } from '../sections/about-us.tsx';
import { ContactUs } from '../sections/contact-us.tsx';
import { FeaturedCourses } from '../sections/featured-courses.tsx';
import { Features } from '../sections/features.tsx';
import { Hero } from '../sections/hero.tsx';
import { RegisterInterest } from '../sections/register-interest.tsx';

export default function Home() {
  usePageMeta({
    title: 'Al Takassusi General Limited Company (ITGL) - Academy',
    description:
      'Advance your healthcare career with our cutting-edge AI courses. Expert-led programs in Applied Healthcare AI, from beginner to advanced levels.',
    pathname: '/',
  });

  return (
    <>
      <Hero />
      <div className="relative">
        <DotPattern
          className={cn(
            'fill-secondary/40 -z-10 [mask-image:radial-gradient(300px_circle_at_left_30%,white,transparent)]',
          )}
        />
        <AboutUs />
        <Features />
        <FeaturedCourses />
        <RegisterInterest />
        <ContactUs />
      </div>
    </>
  );
}
